module.exports = __webpack_public_path__ + "img/hero-man.9de464a8.png";